import React, { useState } from "react";

import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";

import img1 from "../../../assets/img/about/aboutEight/img1.webp";
import img2 from "../../../assets/img/about/aboutEight/img2.webp";
import img3 from "../../../assets/img/about/aboutEight/img3.webp";
import img4 from "../../../assets/img/about/aboutEight/img4.webp";

function AboutEight(){

    const { t } = useTranslation();

    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
        <div className="aboutEight">
            <div className="aboutEightTitle">
                <h1 className={`${isVisible ? 'visible' : ''}`}>{t("about_eight_title")} <span>{t("about_eight_title_span1")}</span>, {t("about_eight_title_but")} <span>{t("about_eight_title_span2")}</span></h1>
                <p className={`${isVisible ? 'visible' : ''}`}>
                    {t("about_eight_text1")}
                </p>
                <p className={`${isVisible ? 'visible' : ''}`}>
                    {t("about_eight_text2")}
                </p>
                <p className={`${isVisible ? 'visible' : ''}`}>
                    {t("about_eight_text3")}
                </p>
            </div>
            <div className="aboutEightImg">
                <img className={`img1 ${isVisible ? 'visible' : ''}`} src={img1} alt="" width={'600px'} />
                <img className={`img2 ${isVisible ? 'visible' : ''}`} src={img2} alt="" width={'600px'} />
                <img className={`img3 ${isVisible ? 'visible' : ''}`} src={img3} alt="" width={'600px'} />
                <img className={`img4 ${isVisible ? 'visible' : ''}`} src={img4} alt="" width={'600px'} />
            </div>
        </div>
        </VisibilitySensor>
    )
}

export default AboutEight;